// @ts-strict-ignore
import * as React from 'react';
import { useMemo } from 'react';
import {
    AllPatternTokens,
    AppNotification,
    CommsChannelAvailableTokens,
    AppNotificationType,
    AppPlatform,
    AppStoreType,
    AppMonitoringHealthMetric,
    AutomationType,
    AutomationHaltPromotePhasedReleaseConditionGroup,
    AutomationAutoStagedRollout,
    BuildDistroNotificationType,
    BundleSizeAlertNotifyFor,
    BundleSizeConditionUnit,
    BundleSizeConditionType,
    BundleSizeIncreaseCondition,
    CommonNotification,
    IntegrationCapability,
    AzureActiveDirectoryProviderData,
    CommsChannel,
    IntegrationGoogle,
    IntegrationMicrosoftTeams,
    IntegrationProvider,
    IntegrationProviderType,
    MicrosoftTeamsChannel,
    IntegrationSlack,
    MonitoringAutomationConditionType,
    NotificationTriggerConditionType,
    NotificationDestination,
    NotificationFrequency,
    OrgUser,
    ProfileOrCertificateType,
    SettingType,
    UserGroup,
    UserGroupId,
    FixRequestReviewNotifyFor,
    IntegrationType,
    Integration,
    LifecycleEventType,
    RelativeTiming,
    ReminderOffset,
} from '../../types';
import {
    BrokenIntegrationDurationUnit,
    BrokenIntegrationFilterMode,
    BrokenIntegrationNotifyMode,
    DEFAULT_BROKEN_INTEGRATION_DURATION_UNIT,
    DEFAULT_BROKEN_INTEGRATION_DURATION_VALUE,
} from '../../types/notifications';
import Text from 'antd/lib/typography/Text';
import Space from 'antd/lib/space';
import { useSelector } from 'react-redux';
import { commsChannelsValidatorFunction, patternTokenSyntaxValidation } from '../../helpers';
import {
    automationAndNotificationSettingsModalContentUsingFormInstance,
    emailValidationRules,
    FieldType,
    filterOptionLabel,
    filterOptionPrefixMatch,
    FormFieldData,
    renderFormFields,
} from '../../helpers/formHelpers';
import { RootState } from '../../reducers/reducers';
import {
    selectAppIntegrations,
    selectAppPlatform,
    selectAppSettings,
    selectAppStoreType,
    selectAutomationsByType,
    selectConnectedCapabilitiesForApp,
    selectJoinedCommsProvidersNamesList,
    selectOrgGroups,
    selectOrgProviders,
    selectStabilityIntegrations,
} from '../../selectors/selectors';
import { AppComponentProps, AppRouteComponentMatchParams, MonitoringConditionOption } from '../../typescriptHelpers';
import Select from 'antd/lib/select';
import { Link, useHistory, useParams } from 'react-router-dom';
import { createAppSettingsRouteWithSettingType } from '../../helpers/routeHelpers';
import Alert from 'antd/lib/alert';
import { globalMessage } from '../../utils/globalMessage';
import Radio from 'antd/lib/radio';
import {
    displayTextForAutomationConditionType,
    displayTextForNotificationTriggerConditionType,
    rolloutNounForAppStoreType,
    displayTextForUserChecklistGroup,
    displayUserNameLong,
    iconForAppNotificationId,
} from '../../helpers/displayHelpers';
import { getIsApplePlatform } from '../../helpers';
import Modal from 'antd/lib/modal';
import Drawer from 'antd/lib/drawer';
import ConfigProvider from 'antd/lib/config-provider';
import Divider from 'antd/lib/divider';
import Switch from 'antd/lib/switch';
import Form from 'antd/lib/form';
import { isEqualWith } from 'lodash';
import TimePicker from 'antd/lib/time-picker';
import { dayjs } from '@/extendedDayjs';
import { selectAppOrgUsers } from '@/selectors/memoizedSelectors';
import { useError, useIsLoading, useUpdated } from '@/utils/hooks/helpers';
import InputNumber from 'antd/lib/input-number';
import IntegrationIcon from '../icons/IntegrationIcon';
import Button from 'antd/lib/button';
import PermissionedActionButton from '../HOCs/PermissionedActionButton';
import { RunwayUserAction } from '../../helpers/aclHelpers';
import * as API from '@/api';
import { SendNotificationTestDMRequest } from '@/actions/app';
import Tooltip from 'antd/lib/tooltip';
import Icon, {
    ArrowRightOutlined,
    ClockCircleOutlined,
    DeleteOutlined,
    InfoCircleOutlined,
    MailOutlined,
    MessageOutlined,
    PlusOutlined,
    ReadOutlined,
    SendOutlined,
    SettingOutlined,
    WarningFilled,
} from '@ant-design/icons';
import { antGrey, colorWithAlpha, runwayColors, rwColors, titleStyle } from '@/components/styles/globalStyles';
import { ReminderOffsetsSettings, REMINDER_OFFSETS_FIELD } from '@/components/sharedComponents/ReminderOffsetsSettings';
import TooltipInfoIcon from '../helperComponents/TooltipInfoIcon';
import { Checkbox, Flex } from 'antd/lib';
import Popover from 'antd/lib/popover';
import { PatternTokenHelperTextComponent } from '@/components/appSettings/PatternTokenHelperTextComponent';
import {
    generateHaltPhasedRolloutConditionGroupsField,
    haltConditionGroupsFormValueToConfig,
    HaltPhasedRolloutConditionGroupFormValue,
    NotificationTriggerOption,
} from '../automations/AutomationSettings';
import {
    automationConditionsForAutomationType,
    docsLinkForNotificationType,
    getRolloutDaysToPercentageFromAutomation,
} from '../../helpers';
import MarkdownEditor from '../HOCs/MarkdownEditor';
import { getPostableTeamsChannels, TeamsChannelOverrideSelect } from './TeamsChannelOverrideSelect';
import Dropdown from 'antd/lib/dropdown';
import { useUserCanPerformAction } from '@/utils/hooks/useUserCanPerformAction';

export enum MentionType {
    MentionGroups = 'mentionGroups',
    MentionUsers = 'mentionUsers',
    ReleasePilot = 'releasePilot',
    None = 'none',
}

enum NotificationDrawerSection {
    Settings = 'settings',
    Channels = 'channels',
    Triggers = 'triggers',
}

enum SlackOption {
    Mentions = 'mentions',
    Channels = 'channels',
    CustomText = 'customText',
}

const SWITCH_ON_LABEL = 'ON';
const SWITCH_OFF_LABEL = 'OFF';
const SWITCH_THEME = {
    trackPadding: 3,
    trackHeight: 24,
    handleSize: 18,
    innerMinMargin: 9,
    innerMaxMargin: 26,
    trackHeightSM: 20,
    handleSizeSM: 14,
    innerMinMarginSM: 7,
    innerMaxMarginSM: 22,
};

const DRAWER_WIDTH = 920;
const DRAWER_NAV_WIDTH = 208;
const SCROLL_SPY_OFFSET_PX = 40;
const SCROLL_SPY_SUPPRESS_MS = 700;
const DEFAULT_MAX_ROLLOUT_DAY = 7;

export interface CommonNotificationSettingsModalProps extends AppComponentProps {
    open: boolean;
    notificationId: string;
    onClose: () => void;
    onAfterClose: () => void;
    actionType: string;

    onSubmit: (formValues: any) => void;
    notification: CommonNotification;
    actionButtonText?: string;
    permissionedActionType?: RunwayUserAction;
    scopeDescription?: React.ReactNode;
}

const NotificationChannelSection: React.FC<{
    title: string;
    icon: React.ReactNode;
    children: React.ReactNode;
    headerAction?: React.ReactNode;
    isChecked?: boolean;
    onToggle?: (checked: boolean) => void;
    disabled?: boolean;
}> = ({ title, icon, children, headerAction, isChecked, onToggle, disabled }) => (
    <div style={{ marginBottom: 16 }}>
        <Flex align="center" justify="space-between" style={{ marginBottom: 16 }}>
            <Space size={16} align="center">
                {onToggle && (
                    <Switch
                        size="small"
                        checked={isChecked}
                        onChange={onToggle}
                        disabled={disabled}
                        checkedChildren={SWITCH_ON_LABEL}
                        unCheckedChildren={SWITCH_OFF_LABEL}
                    />
                )}
                <Flex align="center" gap={8}>
                    {icon}
                    <Text style={{ fontWeight: 600, color: antGrey.grey8, fontSize: 14 }}>{title}</Text>
                </Flex>
            </Space>
            {headerAction}
        </Flex>
        <div
            style={{
                borderRadius: 4,
                padding: 16,
                border: `1px solid ${antGrey.grey5}`,
                backgroundColor: runwayColors.white,
            }}
        >
            {children}
        </div>
    </div>
);

const ChannelOptionToggle: React.FC<{
    label: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
    children: React.ReactNode;
}> = ({ label, checked, onChange, disabled, children }) => (
    <div>
        <Checkbox checked={checked} onChange={(e) => onChange(e.target.checked)} disabled={disabled}>
            {label}
        </Checkbox>
        <div style={{ display: checked ? 'block' : 'none', paddingLeft: 24 }}>{children}</div>
    </div>
);

const FormErrorText: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <Text style={{ color: runwayColors.statusRed, fontSize: 14 }}>{children}</Text>
);

const createErrorField = (errorMessage: string): FormFieldData => ({
    fieldType: FieldType.Custom,
    renderField: () => <FormErrorText>{errorMessage}</FormErrorText>,
    extraFormItemProps: { style: { marginTop: -8, marginBottom: 16 } },
});

const directDownloadAccessOrExpiryRules = [
    ({ getFieldValue }: { getFieldValue: (name: string) => unknown }) => ({
        validator(_: unknown, value: unknown) {
            if (!getFieldValue('includeDirectDownloadLink')) {
                return Promise.resolve();
            }
            if (value === null || value === undefined || value === '') {
                return Promise.resolve();
            }
            const n = Number(value);
            if (!Number.isFinite(n) || n <= 0 || !Number.isInteger(n)) {
                return Promise.reject(new Error('Must be a whole number greater than 0'));
            }
            return Promise.resolve();
        },
    }),
];

const ThreadAndBroadcastCheckboxes: React.FC<{
    notification: CommonNotification;
    isPhasedRolloutNotification: boolean;
    threadCheckboxLabel: string;
    tooltipContent: string;
    isDisabled: boolean;
    isSlackEnabled: boolean;
}> = ({
    notification,
    isPhasedRolloutNotification,
    threadCheckboxLabel,
    tooltipContent,
    isDisabled,
    isSlackEnabled,
}) => {
    const watched = Form.useWatch('threadWithRelatedNotifications');
    const isThreadingOn =
        watched === undefined ? (notification.threadWithRelatedNotifications ?? false) : Boolean(watched);

    return (
        <Space direction="vertical" size={8} style={{ width: '100%', marginBottom: 8 }}>
            <Flex>
                <Form.Item
                    name="threadWithRelatedNotifications"
                    valuePropName="checked"
                    initialValue={notification.threadWithRelatedNotifications ?? false}
                    dependencies={['notificationChannels']}
                    noStyle
                >
                    <Checkbox disabled={isDisabled || !isSlackEnabled}>{threadCheckboxLabel}</Checkbox>
                </Form.Item>
                {tooltipContent && <TooltipInfoIcon tooltipContent={tooltipContent} />}
            </Flex>
            {isPhasedRolloutNotification && (
                <Flex style={{ paddingLeft: 24, display: isThreadingOn ? 'flex' : 'none' }}>
                    <Form.Item
                        name="alsoSendThreadedToChannel"
                        valuePropName="checked"
                        initialValue={notification.alsoSendThreadedToChannel ?? false}
                        noStyle
                    >
                        <Checkbox disabled={isDisabled || !isSlackEnabled}>
                            Also send this notification to channel
                        </Checkbox>
                    </Form.Item>
                </Flex>
            )}
        </Space>
    );
};

/** Sibling of the includeDirectDownloadLink field — must not be nested under that Form.Item or Ant Design treats
 * access/expiry as nested values and overwrites the checkbox boolean when InputNumber updates. */
const DirectDownloadLinkLimitFields: React.FC<{
    notification: AppNotification;
    isDisabled: boolean;
}> = ({ notification, isDisabled }) => {
    const watched = Form.useWatch('includeDirectDownloadLink');
    // useWatch can be undefined before the field is registered; coalesce so we don't treat that as "off" and
    // unmount the limit fields (mount/unmount + layout shift reads as flashing, especially while scrolling).
    const includeOn = watched === undefined ? (notification.includeDirectDownloadLink ?? false) : Boolean(watched);

    return (
        <div
            style={{
                display: includeOn ? 'block' : 'none',
                width: '100%',
                paddingLeft: 24,
            }}
        >
            <Space direction="vertical" style={{ width: '100%' }} size={8}>
                <Form.Item
                    name="directDownloadLinkAccessLimit"
                    label="Max downloads"
                    initialValue={notification.directDownloadLinkAccessLimit ?? null}
                    style={{ marginBottom: 0 }}
                    dependencies={['includeDirectDownloadLink']}
                    rules={directDownloadAccessOrExpiryRules}
                >
                    <InputNumber
                        min={1}
                        precision={0}
                        placeholder="Unlimited"
                        style={{ width: 140 }}
                        disabled={isDisabled}
                    />
                </Form.Item>
                <Form.Item
                    name="directDownloadLinkExpiryHours"
                    label="Expiry (hours)"
                    initialValue={notification.directDownloadLinkExpiryHours ?? null}
                    style={{ marginBottom: 0 }}
                    dependencies={['includeDirectDownloadLink']}
                    rules={directDownloadAccessOrExpiryRules}
                >
                    <InputNumber
                        min={1}
                        precision={0}
                        placeholder="No expiry"
                        style={{ width: 140 }}
                        disabled={isDisabled}
                    />
                </Form.Item>
            </Space>
        </div>
    );
};

const BrokenIntegrationScopeFields: React.FC<{
    notification: AppNotification;
    isDisabled: boolean;
    integrationOptions: { value: string; label: string }[];
}> = ({ notification, isDisabled, integrationOptions }) => {
    const mode =
        Form.useWatch('brokenIntegrationNotifyMode') ??
        notification.brokenIntegrationNotifyMode ??
        BrokenIntegrationNotifyMode.All;

    return (
        <Flex
            gap={8}
            wrap="nowrap"
            style={{
                display: mode === BrokenIntegrationNotifyMode.Specified ? 'flex' : 'none',
                paddingLeft: 24,
                marginTop: 8,
                marginBottom: 16,
            }}
        >
            <Form.Item
                name="brokenIntegrationFilterMode"
                initialValue={notification.brokenIntegrationFilterMode ?? BrokenIntegrationFilterMode.Include}
                style={{ marginBottom: 0 }}
            >
                <Select
                    disabled={isDisabled}
                    style={{ width: 110 }}
                    options={[
                        { value: BrokenIntegrationFilterMode.Include, label: 'Include' },
                        { value: BrokenIntegrationFilterMode.Exclude, label: 'Exclude' },
                    ]}
                />
            </Form.Item>
            <Form.Item
                name="brokenIntegrationInstallationIds"
                initialValue={notification.brokenIntegrationInstallationIds ?? []}
                style={{ marginBottom: 0, flex: 1 }}
                validateTrigger="onBlur"
                rules={[
                    ({ getFieldValue }) => ({
                        validator: (_, value: string[] | undefined) => {
                            if (
                                getFieldValue('brokenIntegrationNotifyMode') ===
                                    BrokenIntegrationNotifyMode.Specified &&
                                (!value || value.length === 0)
                            ) {
                                return Promise.reject(new Error('Select at least one integration'));
                            }
                            return Promise.resolve();
                        },
                    }),
                ]}
            >
                <Select
                    mode="multiple"
                    allowClear
                    maxTagCount="responsive"
                    placeholder="Select integrations"
                    disabled={isDisabled}
                    options={integrationOptions}
                    filterOption={filterOptionLabel}
                />
            </Form.Item>
        </Flex>
    );
};

const MentionTypeSelector: React.FC<{
    isDisabled: boolean;
    isSelectionRequired: boolean;
    getNotificationDestinationsState: (form?: any) => { slack: boolean; email: boolean };
}> = ({ isDisabled, isSelectionRequired, getNotificationDestinationsState }) => {
    const form = Form.useFormInstance();
    const { slack: isSlackEnabled } = getNotificationDestinationsState(form);

    return (
        <>
            <Form.Item
                name="mentionType"
                dependencies={['notificationChannels']}
                style={{ marginTop: 12, marginBottom: 0 }}
                rules={[
                    {
                        validator: (_, mentionType) =>
                            isSelectionRequired && (!mentionType || mentionType === MentionType.None) ?
                                Promise.reject(new Error('Please select who to mention'))
                            :   Promise.resolve(),
                    },
                ]}
                extra="Critical notifications will still mention the release pilot."
            >
                <Radio.Group disabled={isDisabled || !isSlackEnabled}>
                    <Radio value={MentionType.MentionGroups}>User group</Radio>
                    <Radio value={MentionType.MentionUsers}>User</Radio>
                    <Radio value={MentionType.ReleasePilot}>Release pilot</Radio>
                </Radio.Group>
            </Form.Item>
        </>
    );
};

const createDestinationDependentField = (
    base: Omit<FormFieldData, 'renderField'>,
    renderContent: (isSlackEnabled: boolean) => React.ReactNode,
    isDisabled: boolean,
    getDestinationStates: (form?: any) => { slack: boolean; email: boolean },
): FormFieldData => ({
    ...base,
    extraFormItemProps: { ...base.extraFormItemProps, dependencies: ['notificationChannels'] },
    renderField: (data, value, onChange, form) => {
        const { slack: isSlackEnabled } = getDestinationStates(form);
        return renderContent(isSlackEnabled);
    },
});

interface NotificationSettingsSaveButtonProps {
    form: ReturnType<typeof Form.useForm>[0];
    onSave: () => void;
    notificationId: string;
    appPlatform?: AppPlatform;
    loading: boolean;
    actionButtonText?: string;
    permissionedActionType?: RunwayUserAction;
}

const NotificationSettingsSaveButton: React.FC<NotificationSettingsSaveButtonProps> = ({
    form,
    onSave,
    notificationId,
    appPlatform,
    loading,
    actionButtonText,
    permissionedActionType,
}) => {
    const enabledValue = Form.useWatch('enabled', form);
    const bundleSizeConditions = Form.useWatch('bundleSizeIncreaseConditions', form);
    const bundleSizeCellular = Form.useWatch('bundleSizeCellularDownloadLimitThresholdMB', form);
    const isBundleSizeNotification = notificationId === AppNotificationType.BundleSizeIncrease;
    const isApple = appPlatform === undefined || getIsApplePlatform(appPlatform);
    const hasBundleSizeConditions = Array.isArray(bundleSizeConditions) && bundleSizeConditions.length > 0;
    const hasBundleSizeCellular =
        isApple && bundleSizeCellular != null && bundleSizeCellular !== '' && Number(bundleSizeCellular) >= 1;
    const saveDisabledDueToBundleSize =
        isBundleSizeNotification && enabledValue === true && !hasBundleSizeConditions && !hasBundleSizeCellular;

    if (permissionedActionType != null) {
        return (
            <PermissionedActionButton
                actionType={permissionedActionType}
                type="primary"
                loading={loading}
                disabled={saveDisabledDueToBundleSize}
                onClick={onSave}
            >
                {actionButtonText ?? 'Save'}
            </PermissionedActionButton>
        );
    }

    return (
        <Button type="primary" loading={loading} disabled={saveDisabledDueToBundleSize} onClick={onSave}>
            {actionButtonText ?? 'Save'}
        </Button>
    );
};

// The drawer defers rendering its form to a commit after this component mounts, so the pristine
// form values can only be snapshotted from inside the form itself.
const CleanFormSnapshot: React.FC<{ onFormMount: () => void }> = ({ onFormMount }) => {
    React.useEffect(() => {
        onFormMount();
    }, [onFormMount]);
    return null;
};

const isEmptyFormValue = (value: unknown) =>
    value === undefined ||
    value === null ||
    value === '' ||
    value === false ||
    (Array.isArray(value) && value.length === 0);

const withoutEmptyValues = (values: Record<string, unknown>) =>
    Object.keys(values).reduce<Record<string, unknown>>((result, key) => {
        if (!isEmptyFormValue(values[key])) {
            result[key] = values[key];
        }
        return result;
    }, {});

const CommonNotificationSettingsModal: React.FC<CommonNotificationSettingsModalProps> = (
    props: CommonNotificationSettingsModalProps,
) => {
    const [form] = Form.useForm();
    const appStoreType = useSelector((state: RootState) => selectAppStoreType(state, props.appId));
    const stagedRolloutAutomations = useSelector((state: RootState) =>
        selectAutomationsByType(state, props.appId, AutomationType.AutoStagedRollout),
    ) as AutomationAutoStagedRollout[] | undefined;
    const maxRolloutDay = Math.max(
        DEFAULT_MAX_ROLLOUT_DAY,
        ...(stagedRolloutAutomations ?? []).map(
            (automation) => getRolloutDaysToPercentageFromAutomation(automation)?.length ?? 0,
        ),
    );
    const monitoringMetrics = useSelector(
        (state: RootState) => selectAppSettings(state, props.appId)?.monitoringSettings?.metrics,
    );
    const healthMetricsLink = createAppSettingsRouteWithSettingType(
        props.orgId,
        props.appId,
        SettingType.HealthMetrics,
    );

    const mentionType = Form.useWatch('mentionType', form);
    const selectedNotificationChannels = Form.useWatch('notificationChannels', form);
    const enabledValue = Form.useWatch('enabled', form);
    const isDisabled = enabledValue === false;
    const { orgIdParam, appIdParam } = useParams<AppRouteComponentMatchParams>();
    const history = useHistory();

    const notificationsProvider = useSelector((state: RootState) => {
        const integrations = selectAppIntegrations(state, props.appId);
        const notificationsIntegration = integrations.find((integration) =>
            integration.capabilities.includes(IntegrationCapability.Notifications),
        );

        if (notificationsIntegration) {
            const providers = selectOrgProviders(state, props.orgId);
            const notificationsProvider = providers.find(
                (provider) => provider.id === notificationsIntegration.providerId,
            );

            return notificationsProvider;
        }

        return null;
    });

    const notification = props.notification;

    const [slackChecked, setSlackChecked] = React.useState(
        notification.notificationChannels?.includes(NotificationDestination.Slack) ?? true,
    );
    const [emailChecked, setEmailChecked] = React.useState(
        notification.notificationChannels?.includes(NotificationDestination.Email) || false,
    );

    const [slackOptionsChecked, setSlackOptionsChecked] = React.useState<Record<SlackOption, boolean>>({
        [SlackOption.Mentions]:
            !!notification.mentionUsers?.length ||
            !!notification.mentionGroups?.length ||
            !!notification.mentionReleasePilot,
        [SlackOption.Channels]: notification.channels.length > 0,
        [SlackOption.CustomText]: !!notification.customCopy,
    });

    const notificationsIntegration = useSelector((state: RootState) => {
        const integrations = selectAppIntegrations(state, props.appId);
        const notificationsIntegration = integrations.find((integration) =>
            integration.capabilities.includes(IntegrationCapability.Notifications),
        );

        return (
            (notificationsIntegration as IntegrationSlack) || (notificationsIntegration as IntegrationMicrosoftTeams)
        );
    });

    const hasNotificationsIntegration = !!notificationsIntegration;
    const primaryChannels =
        hasNotificationsIntegration ?
            notificationsIntegration.data?.primaryChannels?.map((chan) => chan.name).join(', ')
        :   null;

    const updateNotificationSettingIsLoading = useIsLoading(props.actionType, props.notificationId);
    const updateNotificationSettingSuccess = useUpdated(props.actionType, props.notificationId);
    const updateNotificationSettingError = useError(props.actionType, props.notificationId);

    const handleSaveClick = () => {
        // if disabling a notification, we'll call our submit handler directly
        // so the user isn't blocked by validation errors on fields that no longer matter.
        if (form.getFieldValue('enabled') === false) {
            submitFormValues(form);
        } else {
            form.submit();
        }
    };

    const submitFormValues = async (form) => {
        try {
            const isDisabling = form.getFieldValue('enabled') === false;
            const formValues = isDisabling ? form.getFieldsValue() : await form.validateFields();

            if (formValues.conditionGroups) {
                formValues.conditionGroups = haltConditionGroupsFormValueToConfig(
                    formValues.conditionGroups as HaltPhasedRolloutConditionGroupFormValue[],
                    monitoringMetrics,
                );
                delete formValues.conditionGroupsField;
            }

            return props.onSubmit(formValues);
        } catch (error) {
            globalMessage.error(error.message);
        }
    };

    const [isSendTestDMLoading, setIsSendTestDMLoading] = React.useState(false);
    const [isSavingBeforeSend, setIsSavingBeforeSend] = React.useState(false);
    const sendAfterSaveRef = React.useRef(false);
    const pendingTestChannelIdRef = React.useRef<string | undefined>(undefined);
    const [isTestChannelPickerOpen, setIsTestChannelPickerOpen] = React.useState(false);
    const [testChannelId, setTestChannelId] = React.useState<string | undefined>(undefined);
    const cleanFormSnapshotRef = React.useRef<Record<string, unknown> | null>(null);

    const captureCleanFormSnapshot = React.useCallback(() => {
        cleanFormSnapshotRef.current = form.getFieldsValue(true);
    }, [form]);

    const appUsers = useSelector((state: RootState) => selectAppOrgUsers(state, props.appId));
    const groups = useSelector((state: RootState) => selectOrgGroups(state, props.orgId));

    const connectedCapabilities = useSelector((state: RootState) =>
        selectConnectedCapabilitiesForApp(state, props.appId),
    );
    const stabilityIntegrations = useSelector((state: RootState) => selectStabilityIntegrations(state, props.appId));

    const getNotificationDestinationsState = useMemo(() => {
        return (form?: any) => {
            if (isDisabled) {
                return { slack: false, email: false };
            }
            const currentChannels =
                selectedNotificationChannels ||
                form?.getFieldValue('notificationChannels') ||
                notification.notificationChannels;
            const slack =
                !notification.allowEmails ||
                (currentChannels && currentChannels.includes(NotificationDestination.Slack));
            const email = !!(currentChannels && currentChannels.includes(NotificationDestination.Email));
            return { slack, email };
        };
    }, [selectedNotificationChannels, notification, isDisabled]);

    const handleChannelCheckboxChange = (channel: NotificationDestination, checked: boolean) => {
        if (channel === NotificationDestination.Slack) {
            setSlackChecked(checked);
        } else {
            setEmailChecked(checked);
        }

        const currentChannels = form.getFieldValue('notificationChannels') || [];
        const updatedChannels =
            checked ?
                [...currentChannels.filter((c) => c !== channel), channel]
            :   currentChannels.filter((c) => c !== channel);
        form.setFieldsValue({ notificationChannels: updatedChannels });
    };

    React.useEffect(() => {
        if (updateNotificationSettingSuccess) {
            globalMessage.success('Updated notification settings!');
            if (sendAfterSaveRef.current) {
                // Keep the modal open if user clicked "Save and send test DM"
                sendAfterSaveRef.current = false;
                setIsSavingBeforeSend(false);
                captureCleanFormSnapshot();
                sendTest(pendingTestChannelIdRef.current);
            } else {
                props.onClose();
            }
        }
    }, [updateNotificationSettingSuccess]);

    React.useEffect(() => {
        if (updateNotificationSettingError) {
            sendAfterSaveRef.current = false;
            setIsSavingBeforeSend(false);
            globalMessage.error(updateNotificationSettingError);
        }
    }, [updateNotificationSettingError]);

    React.useEffect(() => {
        if (!mentionType) {
            return;
        }
        if (mentionType === MentionType.None) {
            form.setFieldsValue({
                [MentionType.MentionUsers]: [],
                [MentionType.MentionGroups]: [],
                mentionReleasePilot: false,
            });
        } else if (mentionType === MentionType.ReleasePilot) {
            form.setFieldsValue({
                [MentionType.MentionUsers]: [],
                [MentionType.MentionGroups]: [],
                mentionReleasePilot: true,
            });
        } else {
            const otherField =
                mentionType === MentionType.MentionGroups ? MentionType.MentionUsers : MentionType.MentionGroups;
            form.setFieldsValue({ [otherField]: [], mentionReleasePilot: false });
        }
    }, [mentionType, form]);

    const auth = useSelector((state: RootState) => state.auth);
    const authCredentials = auth.authCredentials;

    const isSlackIncomingWebhookOverrideConfigured = !!useSelector(
        (state: RootState) => selectAppSettings(state, props.appId)?.isSlackIncomingWebhookOverrideConfigured,
    );

    const sendTest = (channelId?: string) => {
        const requestData: SendNotificationTestDMRequest = {
            orgId: props.orgId,
            appId: props.appId,
            notificationId: notification.id,
            channelId,
        };

        setIsSendTestDMLoading(true);

        API.sendNotificationTestDM(requestData, authCredentials)
            .then(() => {
                globalMessage.success(
                    channelId || isSlackIncomingWebhookOverrideConfigured ? 'Test message sent!' : 'Test DM sent!',
                );
                return;
            })
            .catch((e) => {
                globalMessage.error(e.message);
                return;
            })
            .finally(() => setIsSendTestDMLoading(false));
    };

    const isFormDirty = () => {
        const baseline = cleanFormSnapshotRef.current;
        if (!baseline) {
            return false;
        }
        // Effects reacting to watched fields write empty values for fields that had no entry in the
        // store yet (e.g. mentionUsers when nobody is mentioned), so ignore empty values on both sides.
        return !isEqualWith(withoutEmptyValues(baseline), withoutEmptyValues(form.getFieldsValue(true)), (a, b) => {
            if ((typeof a === 'string' && typeof b === 'number') || (typeof a === 'number' && typeof b === 'string')) {
                return a == b;
            }
            if ((a === null && b === '') || (a === '' && b === null)) {
                return true;
            }
            if ((a === undefined && b === null) || (a === null && b === undefined)) {
                return true;
            }
            return undefined;
        });
    };

    const handleSaveAndSendTestDM = async () => {
        try {
            await form.validateFields();
        } catch {
            return;
        }
        sendAfterSaveRef.current = true;
        setIsSavingBeforeSend(true);
        handleSaveClick();
    };

    const handleSendTestClick = (channelId?: string) => {
        pendingTestChannelIdRef.current = channelId;
        if (isFormDirty()) {
            Modal.confirm({
                title: 'You have unsaved changes',
                icon: null,
                maskClosable: true,
                okText: channelId ? 'Save and send test' : 'Save and send test DM',
                cancelText: 'Cancel',
                onOk: handleSaveAndSendTestDM,
            });
        } else {
            sendTest(channelId);
        }
    };

    const showNotificationTestSend = !!notificationsIntegration || isSlackIncomingWebhookOverrideConfigured;
    const testSendUnsupported = !!notification.testSendUnsupported;
    const canUpdateAppSettings = useUserCanPerformAction(
        RunwayUserAction.UAUpdateAppSettings,
        undefined,
        undefined,
        undefined,
        undefined,
        props.appId,
    );
    const showSendTestToChannel =
        !!notificationsIntegration && !isSlackIncomingWebhookOverrideConfigured && !testSendUnsupported;
    const isTeamsNotificationsProvider = notificationsProvider?.type === IntegrationProviderType.AzureActiveDirectory;
    const testChannelOptions =
        isTeamsNotificationsProvider ?
            getPostableTeamsChannels(notificationsProvider.data as AzureActiveDirectoryProviderData).map((channel) => ({
                value: channel.id,
                label: channel.displayName,
            }))
        :   ((notificationsProvider?.data?.availableChannels ?? []) as CommsChannel[]).map((channel) => ({
                value: channel.id,
                label: channel.name,
            }));

    const closeTestChannelPicker = () => {
        setIsTestChannelPickerOpen(false);
        setTestChannelId(undefined);
    };

    const handleSendTestToChannelOk = () => {
        const channelId = testChannelId;
        closeTestChannelPicker();
        handleSendTestClick(channelId);
    };

    const testSendButtonLabel = isSlackIncomingWebhookOverrideConfigured ? 'Send test message' : 'Send test DM';
    const isTestSendInFlight = isSavingBeforeSend || isSendTestDMLoading;
    const isTestSendDisabled = testSendUnsupported || isTestSendInFlight;

    const slackHeaderAction =
        showNotificationTestSend ?
            <Space size={6}>
                <Tooltip
                    title={testSendUnsupported ? "Test sends aren't yet available for this notification." : undefined}
                >
                    {showSendTestToChannel ?
                        <Dropdown.Button
                            size="small"
                            trigger={['click']}
                            disabled={isTestSendDisabled}
                            loading={isTestSendInFlight}
                            onClick={() => handleSendTestClick()}
                            menu={{
                                items: [
                                    {
                                        key: 'channel',
                                        label: 'Send test to channel',
                                        icon: <SendOutlined style={{ color: rwColors.primary }} />,
                                        disabled: !canUpdateAppSettings,
                                    },
                                ],
                                onClick: () => setIsTestChannelPickerOpen(true),
                            }}
                            buttonsRender={([leftButton, rightButton]) => [
                                React.cloneElement(leftButton as React.ReactElement, {
                                    icon: <MessageOutlined style={{ color: rwColors.primary }} />,
                                }),
                                rightButton,
                            ]}
                        >
                            {testSendButtonLabel}
                        </Dropdown.Button>
                    :   <Button
                            size="small"
                            icon={<MessageOutlined style={{ color: rwColors.primary }} />}
                            disabled={isTestSendDisabled}
                            loading={isTestSendInFlight}
                            onClick={() => handleSendTestClick()}
                        >
                            {testSendButtonLabel}
                        </Button>
                    }
                </Tooltip>
                <Modal
                    open={isTestChannelPickerOpen}
                    title="Send test to channel"
                    okText="Send test"
                    okButtonProps={{ disabled: !testChannelId }}
                    onOk={handleSendTestToChannelOk}
                    onCancel={closeTestChannelPicker}
                    destroyOnClose
                >
                    <Select
                        style={{ width: '100%' }}
                        placeholder={isTeamsNotificationsProvider ? 'Select a channel' : 'Select or enter a channel ID'}
                        mode={isTeamsNotificationsProvider ? undefined : 'tags'}
                        maxCount={1}
                        showSearch
                        allowClear
                        notFoundContent={null}
                        optionFilterProp="label"
                        options={testChannelOptions}
                        value={testChannelId}
                        onChange={(value: string | string[]) =>
                            setTestChannelId(Array.isArray(value) ? value[0] : value)
                        }
                    />
                </Modal>
            </Space>
        :   null;

    const appPlatform = useSelector((state: RootState) => selectAppPlatform(state, props.appId));
    const commsProviders = useSelector(selectJoinedCommsProvidersNamesList);
    const appIntegrations = useSelector((state: RootState) => selectAppIntegrations(state, props.appId));

    const notificationsIntegrationComponentRoute = createAppSettingsRouteWithSettingType(
        orgIdParam,
        appIdParam,
        SettingType.Integrations,
    );

    const reviewNotificationIds = new Set<AppNotificationType>([
        AppNotificationType.IndividualReview,
        AppNotificationType.DailyUserReviewsDigest,
        AppNotificationType.WeeklyUserReviewsIssuesDigest,
    ]);
    const googlePlayIntegration = appIntegrations.find((integration) => integration.id === IntegrationType.Google) as
        | IntegrationGoogle
        | undefined;
    const showConsoleAppIdHint =
        reviewNotificationIds.has(notification.id as AppNotificationType) &&
        !!googlePlayIntegration &&
        !googlePlayIntegration.data?.consoleAppId;
    const consoleAppIdAlert =
        showConsoleAppIdHint ?
            <Alert
                type="info"
                message={
                    <Text>
                        Add a Play Console app ID in{' '}
                        <Link to={notificationsIntegrationComponentRoute}>Integration settings</Link> to get direct
                        links to reviews.
                    </Text>
                }
                style={{ marginBottom: 24, borderRadius: 4 }}
            />
        :   undefined;

    const formFieldSections = notificationSettingFormFieldsForNotification({
        notification,
        provider: notificationsProvider,
        appIntegrations,
        hasNotificationsIntegration,
        userGroups: groups,
        mentionType,
        appUsers,
        primaryChannels,
        selectedNotificationChannels,
        isDisabled,
        getNotificationDestinationsState,
        connectedCapabilities,
        stabilityIntegrations,
        appPlatform,
        commsProviders,
        appStoreType,
        maxRolloutDay,
        monitoringMetrics,
        healthMetricsLink,
        checkboxActions: {
            slackChecked,
            emailChecked,
            handleChannelCheckboxChange,
            slackHeaderAction,
            slackOptions: {
                [SlackOption.Mentions]: {
                    checked: slackOptionsChecked[SlackOption.Mentions],
                    onChange: (checked) => {
                        setSlackOptionsChecked((prev) => ({ ...prev, [SlackOption.Mentions]: checked }));
                        if (!checked) {
                            form.setFieldsValue({ mentionType: MentionType.None });
                        }
                    },
                },
                [SlackOption.Channels]: {
                    checked: slackOptionsChecked[SlackOption.Channels],
                    onChange: (checked) => {
                        setSlackOptionsChecked((prev) => ({ ...prev, [SlackOption.Channels]: checked }));
                        if (!checked) {
                            form.setFieldsValue({ channels: [] });
                        }
                    },
                },
                [SlackOption.CustomText]: {
                    checked: slackOptionsChecked[SlackOption.CustomText],
                    onChange: (checked) => {
                        setSlackOptionsChecked((prev) => ({ ...prev, [SlackOption.CustomText]: checked }));
                        if (!checked) {
                            form.setFieldsValue({ customCopy: '' });
                        }
                    },
                },
            },
        },
    });
    const notificationDescription = !!notification.info && (
        <Flex
            justify="space-between"
            align="stretch"
            style={{
                backgroundColor: antGrey.grey2,
                border: `1px solid ${antGrey.grey5}`,
                borderRadius: 4,
                padding: '16px 20px',
                marginBottom: 20,
            }}
        >
            <Flex vertical gap={16} style={{ flex: 1, minWidth: 0 }}>
                <Text type="secondary">Runway will send a notification when...</Text>
                <Text style={{ fontSize: 16, color: antGrey.grey8 }}>{notification.info}</Text>
            </Flex>
            <Divider
                type="vertical"
                style={{
                    height: 'auto',
                    alignSelf: 'stretch',
                    margin: '0 20px',
                    borderColor: antGrey.grey5,
                }}
            />
            <Button
                shape="round"
                icon={<ReadOutlined />}
                href={docsLinkForNotificationType(notification.id)}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    flexShrink: 0,
                    alignSelf: 'flex-start',
                    color: runwayColors.primary,
                    borderColor: runwayColors.primaryLight,
                    padding: '2px 12px',
                }}
            >
                Docs <ArrowRightOutlined />
            </Button>
        </Flex>
    );

    const sections = [
        {
            key: NotificationDrawerSection.Settings,
            label: 'Settings',
            title: 'Notification settings',
            icon: SettingOutlined,
            fields: formFieldSections.settings,
            leading: (
                <>
                    {notificationDescription}
                    {props.scopeDescription}
                    {renderFormFields([formFieldSections.enabled])}
                </>
            ),
        },
        {
            key: NotificationDrawerSection.Channels,
            label: 'Channels',
            title: 'Channels',
            icon: SendOutlined,
            fields: formFieldSections.channels,
            leading: null,
        },
        {
            key: NotificationDrawerSection.Triggers,
            label: 'Triggers',
            title: 'Triggers',
            icon: ClockCircleOutlined,
            fields: formFieldSections.triggers,
            leading: null,
        },
    ].filter((section) => section.key === NotificationDrawerSection.Settings || section.fields.length > 0);

    const [activeSection, setActiveSection] = React.useState(sections[0].key);
    const sectionRefs = React.useRef<Partial<Record<NotificationDrawerSection, HTMLDivElement | null>>>({});

    const programmaticScrollTimeoutRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);

    const scrollToSection = (section: NotificationDrawerSection) => {
        setActiveSection(section);
        if (programmaticScrollTimeoutRef.current) {
            clearTimeout(programmaticScrollTimeoutRef.current);
        }
        programmaticScrollTimeoutRef.current = setTimeout(() => {
            programmaticScrollTimeoutRef.current = null;
        }, SCROLL_SPY_SUPPRESS_MS);
        sectionRefs.current[section]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const handleContentScroll = (container: HTMLElement) => {
        if (programmaticScrollTimeoutRef.current) {
            return;
        }
        const isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 1;
        if (isAtBottom) {
            setActiveSection(sections[sections.length - 1].key);
            return;
        }
        const containerTop = container.getBoundingClientRect().top;
        let current = sections[0].key;
        for (const section of sections) {
            const element = sectionRefs.current[section.key];
            if (element && element.getBoundingClientRect().top - containerTop <= SCROLL_SPY_OFFSET_PX) {
                current = section.key;
            }
        }
        setActiveSection(current);
    };

    const formContent = automationAndNotificationSettingsModalContentUsingFormInstance(
        form,
        [formFieldSections.enabled].concat(...sections.map((section) => section.fields)),
        false,
        submitFormValues,
        <>
            {sections.map((section, index) => (
                <div
                    key={section.key}
                    ref={(element) => {
                        sectionRefs.current[section.key] = element;
                    }}
                >
                    {index > 0 && <Divider style={{ margin: '24px 0', borderColor: antGrey.grey5 }} />}
                    <Text style={{ ...titleStyle, fontWeight: 400, fontSize: 14, marginBottom: 24, display: 'block' }}>
                        {section.title}
                    </Text>
                    <div className="notification-drawer-section-fields">
                        {section.leading}
                        {renderFormFields(section.fields)}
                    </div>
                </div>
            ))}
            <CleanFormSnapshot onFormMount={captureCleanFormSnapshot} />
        </>,
    );

    return (
        <Drawer
            open={props.open}
            destroyOnClose
            width={DRAWER_WIDTH}
            closeIcon={false}
            onClose={props.onClose}
            afterOpenChange={(open) => {
                if (!open) {
                    form.resetFields();
                    props.onAfterClose();
                }
            }}
            title={
                <div style={{ display: 'flex', alignItems: 'center', gap: 16, minWidth: 0 }}>
                    <Icon
                        component={iconForAppNotificationId(notification.id)}
                        style={{ fontSize: 24, color: antGrey.grey6, flexShrink: 0 }}
                    />
                    <Text
                        ellipsis={{ tooltip: notification.displayText }}
                        style={{ fontSize: 16, fontWeight: 600, color: antGrey.grey8, minWidth: 0 }}
                    >
                        {notification.displayText}
                    </Text>
                </div>
            }
            extra={
                <NotificationSettingsSaveButton
                    form={form}
                    onSave={handleSaveClick}
                    notificationId={notification.id}
                    appPlatform={appPlatform}
                    loading={updateNotificationSettingIsLoading}
                    actionButtonText={props.actionButtonText}
                    permissionedActionType={props.permissionedActionType}
                />
            }
            styles={{
                header: { backgroundColor: antGrey.grey3 },
                body: { display: 'flex', paddingTop: 24, paddingBottom: 24, paddingLeft: 0, paddingRight: 0 },
            }}
        >
            <ConfigProvider theme={{ components: { Switch: SWITCH_THEME } }}>
                <Flex
                    vertical
                    style={{
                        width: DRAWER_NAV_WIDTH,
                        flexShrink: 0,
                        borderRight: `1px solid ${antGrey.grey5}`,
                    }}
                >
                    <Flex vertical gap={10} style={{ padding: '0 4px' }}>
                        {sections.map((section) => {
                            const isActive = section.key === activeSection;
                            const SectionIcon = section.icon;
                            return (
                                <Button
                                    key={section.key}
                                    type="text"
                                    block
                                    onClick={() => scrollToSection(section.key)}
                                    style={{
                                        height: 'auto',
                                        padding: '12px 16px',
                                        justifyContent: 'flex-start',
                                        borderRadius: 4,
                                        backgroundColor: isActive ? colorWithAlpha(rwColors.primary, 0.1) : undefined,
                                    }}
                                >
                                    <Flex align="center" gap={12}>
                                        <SectionIcon
                                            style={{
                                                fontSize: 16,
                                                color: isActive ? runwayColors.primary : antGrey.grey7,
                                            }}
                                        />
                                        <Text
                                            style={{
                                                color: isActive ? runwayColors.primary : antGrey.grey9,
                                                fontWeight: isActive ? 600 : 400,
                                            }}
                                        >
                                            {section.label}
                                        </Text>
                                    </Flex>
                                </Button>
                            );
                        })}
                    </Flex>
                </Flex>
                <Flex
                    vertical
                    style={{ flex: 1, minWidth: 0, overflowY: 'auto', padding: '0px 24px' }}
                    onScroll={(event) => handleContentScroll(event.currentTarget)}
                >
                    {!hasNotificationsIntegration && (
                        <Alert
                            type="warning"
                            showIcon
                            message="Notifications cannot be sent until a Notifications integration is configured."
                            action={
                                <Button
                                    type="text"
                                    size="small"
                                    style={{
                                        marginLeft: 16,
                                        whiteSpace: 'nowrap',
                                        letterSpacing: titleStyle.letterSpacing,
                                        textTransform: 'uppercase',
                                    }}
                                    onClick={() => history.push(notificationsIntegrationComponentRoute)}
                                >
                                    Integrations <ArrowRightOutlined />
                                </Button>
                            }
                            style={{ marginBottom: 24, borderRadius: 4 }}
                        />
                    )}
                    {consoleAppIdAlert}
                    <div>{formContent}</div>
                </Flex>
            </ConfigProvider>
        </Drawer>
    );
};

export default CommonNotificationSettingsModal;

interface NotificationFormFieldsProps {
    notification: AppNotification;
    provider: IntegrationProvider;
    hasNotificationsIntegration: boolean;
    userGroups: Record<UserGroupId, UserGroup>;
    mentionType?: MentionType;
    appUsers: OrgUser[];
    primaryChannels?: string | null;
    selectedNotificationChannels?: NotificationDestination[];
    isDisabled: boolean;
    getNotificationDestinationsState: (form?: any) => { slack: boolean; email: boolean };
    connectedCapabilities: IntegrationCapability[];
    stabilityIntegrations: Integration[];
    appPlatform?: AppPlatform;
    commsProviders: string;
    appIntegrations: Integration[];
    appStoreType?: AppStoreType;
    maxRolloutDay: number;
    monitoringMetrics?: AppMonitoringHealthMetric[];
    healthMetricsLink?: string;
    checkboxActions?: {
        slackChecked: boolean;
        emailChecked: boolean;
        handleChannelCheckboxChange: (channel: NotificationDestination, checked: boolean) => void;
        slackHeaderAction: React.ReactNode;
        slackOptions: Record<SlackOption, { checked: boolean; onChange: (checked: boolean) => void }>;
    };
}

interface NotificationFormFieldSections {
    enabled: FormFieldData;
    settings: FormFieldData[];
    channels: FormFieldData[];
    triggers: FormFieldData[];
}

const legacyThresholdsAsConditionGroups = (
    notification: AppNotification,
    stabilityIntegrations: Integration[],
): AutomationHaltPromotePhasedReleaseConditionGroup[] => {
    let adoptionThresholds = notification.adoptionThresholds;
    if (!adoptionThresholds && notification.adoptionThreshold && stabilityIntegrations.length === 1) {
        adoptionThresholds = { [stabilityIntegrations[0].installationId]: notification.adoptionThreshold };
    }
    if (!adoptionThresholds && !notification.phasedReleaseDayThreshold) {
        return [];
    }
    return [
        {
            id: 'condition-group-legacy',
            name: 'Group 1',
            adoptionThresholds,
            phasedReleaseDayThreshold: notification.phasedReleaseDayThreshold,
            monitoringConditions: [],
        },
    ];
};

const notificationSettingFormFieldsForNotification = ({
    notification,
    provider,
    hasNotificationsIntegration,
    userGroups,
    mentionType,
    appUsers,
    primaryChannels,
    isDisabled,
    getNotificationDestinationsState,
    connectedCapabilities,
    stabilityIntegrations,
    appPlatform,
    commsProviders,
    appIntegrations,
    appStoreType,
    maxRolloutDay,
    monitoringMetrics,
    healthMetricsLink,
    checkboxActions,
}: NotificationFormFieldsProps): NotificationFormFieldSections => {
    const hasProviderAndNotificationIntegration = provider && hasNotificationsIntegration;
    const availableChannels = provider?.data?.availableChannels || [];
    const selectedMentionType =
        notification.mentionUsers?.length ? MentionType.MentionUsers
        : notification.mentionGroups?.length ? MentionType.MentionGroups
        : notification.mentionReleasePilot ? MentionType.ReleasePilot
        : MentionType.None;
    const isMentionedUsersType = mentionType === MentionType.MentionUsers;
    const isMentionedUserGroupsType = mentionType === MentionType.MentionGroups;

    const showHourOfDaySetting =
        notification.id == AppNotificationType.ApprovalItemsReminder ||
        notification.id == AppNotificationType.RegressionItemsReminder;

    const showFrequencySetting = notification.id == AppNotificationType.WeeklyUserReviewsIssuesDigest;

    const showExpirationWarningDayPeriodSetting =
        notification.id == AppNotificationType.NoteExpiringAppleProfilesCertificates;

    const showMonitoringConditionsSetting = notification.id == AppNotificationType.HealthMetricsWarning;

    const showBundleSizeSettings = notification.id == AppNotificationType.BundleSizeIncrease;

    const reminderOffsetsEvent =
        notification.id === AppNotificationType.TargetKickoffReminder ? LifecycleEventType.LifecycleEventTypeKickoff
        : notification.id === AppNotificationType.TargetSubmitReminder ? LifecycleEventType.LifecycleEventTypeSubmit
        : notification.id === AppNotificationType.TargetReleaseReminder ? LifecycleEventType.LifecycleEventTypeRelease
        : undefined;

    const showIncludeNewIssuesSetting = notification.id == AppNotificationType.AppStorePhasedReleaseUpdate;
    const isSlackProvider = provider?.type === IntegrationProviderType.Slack;
    const notificationsChannelTitle =
        provider?.type === IntegrationProviderType.AzureActiveDirectory ? 'Teams notifications' : 'Slack notifications';
    const phasedRolloutNotificationIds = new Set<AppNotificationType>([
        AppNotificationType.AppStorePhasedReleaseUpdate,
        AppNotificationType.AppStorePhasedReleaseComplete,
        AppNotificationType.StablePhasedReleasePromoted,
        AppNotificationType.UnstablePhasedReleaseHalted,
        AppNotificationType.GoogleCustomStagedRolloutManuallyStarted,
        AppNotificationType.GoogleCustomStageRolloutFailedToStart,
    ]);
    const isPhasedRolloutNotification = phasedRolloutNotificationIds.has(notification.id as AppNotificationType);
    const rolloutTypeWord =
        (
            notification.id === AppNotificationType.GoogleCustomStagedRolloutManuallyStarted ||
            notification.id === AppNotificationType.GoogleCustomStageRolloutFailedToStart
        ) ?
            'staged'
        :   'phased';

    const showThreadWithRelatedNotifications =
        isSlackProvider &&
        (isPhasedRolloutNotification ||
            [
                AppNotificationType.RegressionBuildUpdated,
                AppNotificationType.RegressionStatusUpdated,
                AppNotificationType.ChecklistItemComment,
                AppNotificationType.BumpVersionPRMerged,
                AppNotificationType.BetaFeedback,
            ].includes(notification.id as AppNotificationType));

    const showThreadHealthMetrics =
        isSlackProvider &&
        [
            AppNotificationType.AppStorePhasedReleaseUpdate,
            AppNotificationType.AppStorePhasedReleaseComplete,
            AppNotificationType.UnstablePhasedReleaseHalted,
            AppNotificationType.StablePhasedReleasePromoted,
        ].includes(notification.id as AppNotificationType);

    const threadWithRelatedNotificationsTooltip = (notificationId: AppNotificationType): string => {
        if (phasedRolloutNotificationIds.has(notificationId)) {
            return `Runway will thread multiple notifications about your ${rolloutTypeWord} release off of the earliest one, including other notification types (if this option is enabled on other notification types about ${rolloutTypeWord} releases).`;
        }
        switch (notificationId) {
            case AppNotificationType.RegressionBuildUpdated:
                return 'Runway will also send notifications about failed regression builds to the channel.';
            case AppNotificationType.RegressionStatusUpdated:
                return 'Runway will also send notifications about failed regression tests to the channel.';
            case AppNotificationType.BumpVersionPRMerged:
                return 'Runway will also send notifications about merged bump version PRs to the channel.';
            case AppNotificationType.BetaFeedback:
                return 'Runway will thread notifications about feedback on the same beta build off of the earliest one.';
            default:
                return '';
        }
    };

    const slackOptions = checkboxActions?.slackOptions;
    const isSlackToggledOff = notification.allowEmails && checkboxActions?.slackChecked === false;
    const optionsDisabled = isDisabled || isSlackToggledOff;
    const isSlackOptionRequired = (option: SlackOption) => !optionsDisabled && !!slackOptions?.[option].checked;

    const mentionedGroupsField: FormFieldData = createDestinationDependentField(
        {
            label: 'User groups',
            name: MentionType.MentionGroups,
            initialValue: notification.mentionGroups || [],
            fieldType: FieldType.Custom,
            extraFormItemProps: { hidden: !isMentionedUserGroupsType },
            rules: [
                ({ getFieldValue }) => ({
                    validator: (_, value) =>
                        (
                            isSlackOptionRequired(SlackOption.Mentions) &&
                            getFieldValue('mentionType') === MentionType.MentionGroups &&
                            !(value?.length > 0)
                        ) ?
                            Promise.reject(new Error('Select at least one user group'))
                        :   Promise.resolve(),
                }),
            ],
        },
        (isSlackEnabled) => (
            <Select
                disabled={isDisabled || !isSlackEnabled}
                mode="multiple"
                allowClear
                placeholder="Select a user group/groups"
                filterOption={filterOptionPrefixMatch}
            >
                {Object.keys(userGroups)
                    .filter((groupId) => !userGroups[groupId]?.disabled)
                    .map((groupId, index) => (
                        <Select.Option key={index} value={groupId}>
                            {displayTextForUserChecklistGroup(userGroups[groupId])}
                        </Select.Option>
                    ))}
            </Select>
        ),
        isDisabled,
        getNotificationDestinationsState,
    );

    const mentionedUsersField: FormFieldData = createDestinationDependentField(
        {
            label: 'Users',
            name: MentionType.MentionUsers,
            initialValue: notification.mentionUsers || [],
            fieldType: FieldType.Custom,
            extraFormItemProps: { hidden: !isMentionedUsersType },
            rules: [
                ({ getFieldValue }) => ({
                    validator: (_, value) =>
                        (
                            isSlackOptionRequired(SlackOption.Mentions) &&
                            getFieldValue('mentionType') === MentionType.MentionUsers &&
                            !(value?.length > 0)
                        ) ?
                            Promise.reject(new Error('Select at least one user'))
                        :   Promise.resolve(),
                }),
            ],
        },
        (isSlackEnabled) => (
            <Select
                disabled={isDisabled || !isSlackEnabled}
                allowClear
                mode="multiple"
                maxTagCount={'responsive'}
                placeholder="Select a user/users"
            >
                {appUsers.map((user, index) => (
                    <Select.Option value={user.email} key={index}>
                        {displayUserNameLong(user)}
                    </Select.Option>
                ))}
            </Select>
        ),
        isDisabled,
        getNotificationDestinationsState,
    );
    const enabledField: FormFieldData = {
        label: 'Enabled',
        name: 'enabled',
        initialValue: notification.enabled,
        fieldType: FieldType.Switch,
        switchOnText: SWITCH_ON_LABEL,
        switchOffText: SWITCH_OFF_LABEL,
        rules: [{ required: true }],
        extraFormItemProps: { required: false },
        style: { marginTop: 0, marginBottom: 24 },
    };
    const fields: FormFieldData[] = [];
    const triggerFields: FormFieldData[] = [];
    const channelFields: FormFieldData[] = [];

    const hourOfDaySettingHelpMessage = (notificationId: AppNotificationType): string => {
        switch (notificationId) {
            case AppNotificationType.ApprovalItemsReminder:
                return 'Choose the hour at which the reminder will be sent. Approval item reminders start a few hours after kickoff, or a few hours before submission.';
            case AppNotificationType.RegressionItemsReminder:
                return 'Choose the hour at which the reminder will be sent. Regression item reminders start when the Regression step becomes active and are sent every day until all items are complete.';
            default:
                return '';
        }
    };

    if (showHourOfDaySetting) {
        const hourOfDayUTC =
            notification.hourOfDayForNotification ? dayjs.utc().hour(notification.hourOfDayForNotification) : null;
        const hourOfDay = hourOfDayUTC ? dayjs(hourOfDayUTC).local() : null;
        const hourOfDayField = {
            label: 'Reminder time',
            name: 'hourOfDay',
            fieldType: FieldType.Custom,
            initialValue: hourOfDay,
            helpMessage: hourOfDaySettingHelpMessage(notification.id as AppNotificationType),
            renderField: () => {
                return <TimePicker format="h:00 A" showNow={false} style={{ width: '100%' }} />;
            },
        };
        triggerFields.push(hourOfDayField);
    }

    if (showFrequencySetting) {
        const frequencyField = {
            label: 'Frequency',
            name: 'notificationFrequency',
            fieldType: FieldType.Custom,
            initialValue: notification.notificationFrequency ?? NotificationFrequency.Weekly,
            helpMessage: 'Digests are only sent if new issues are found.',
            renderField: () => {
                return (
                    <Select style={{ width: '100%' }} disabled={isDisabled}>
                        <Select.Option value={NotificationFrequency.Daily}>Daily</Select.Option>
                        <Select.Option value={NotificationFrequency.Weekly}>Weekly</Select.Option>
                    </Select>
                );
            },
        };
        triggerFields.push(frequencyField);
    }

    if (showExpirationWarningDayPeriodSetting) {
        const profileCertsExpirationWarningDay =
            notification.appleProfileAndCertificateReminderDaysBeforeExpiration ?
                notification.appleProfileAndCertificateReminderDaysBeforeExpiration
            :   14;
        const appleProfileAndCertificateReminderDaysBeforeExpiration = {
            label: 'Reminders should start',
            name: 'appleProfileAndCertificateReminderDaysBeforeExpiration',
            fieldType: FieldType.Custom,
            initialValue: profileCertsExpirationWarningDay,
            helpMessage: 'ahead of profile and certification expiration',
            renderField: () => {
                return (
                    <InputNumber
                        min={1}
                        max={365}
                        precision={0}
                        type="number"
                        addonAfter="days"
                        defaultValue={profileCertsExpirationWarningDay}
                    />
                );
            },
        };

        const profileAndCertificateSelectOptions = Object.values(ProfileOrCertificateType).map((type) => ({
            value: type,
            label: type,
        }));

        const profileAndCertificateSelectOption = {
            label: 'Profile and certificate types',
            name: 'selectedProfileAndCertificateTypes',
            initialValue: notification.selectedProfileAndCertificateTypes ?? [],
            fieldType: FieldType.Custom,
            helpMessage:
                'Runway will send upcoming expiry reminders for the selected profile and certificate types only. Leave blank to send reminders for all profile and certificate types.',
            renderField: () => {
                return <Select options={profileAndCertificateSelectOptions} mode="multiple" />;
            },
        };

        fields.push(profileAndCertificateSelectOption);
        triggerFields.push(appleProfileAndCertificateReminderDaysBeforeExpiration);
    }

    if (reminderOffsetsEvent) {
        const initialOffsets: ReminderOffset[] =
            notification.reminderOffsets?.length ?
                notification.reminderOffsets
            :   [
                    { days: 0, hours: 24, minutes: 0, timing: RelativeTiming.before },
                    { days: 0, hours: 0, minutes: 30, timing: RelativeTiming.before },
                ];
        triggerFields.push({
            label: 'Send reminder(s)...',
            name: REMINDER_OFFSETS_FIELD,
            fieldType: FieldType.Custom,
            initialValue: initialOffsets,
            style: { paddingBottom: 10 },
            rules: [
                () => ({
                    validator: (_, value: ReminderOffset[] | undefined) => {
                        const offsets = value || [];
                        if (offsets.length === 0) {
                            return Promise.reject(new Error('Add at least one reminder'));
                        }
                        const hasEmptyBeforeRow = offsets.some(
                            (o) =>
                                o?.timing === RelativeTiming.before &&
                                !(o.days || 0) &&
                                !(o.hours || 0) &&
                                !(o.minutes || 0),
                        );
                        if (hasEmptyBeforeRow) {
                            return Promise.reject(
                                new Error('Set a time for each "before" reminder, or choose "at the time of"'),
                            );
                        }
                        return Promise.resolve();
                    },
                }),
            ],
            renderField: () => <ReminderOffsetsSettings event={reminderOffsetsEvent} />,
        });
    }

    if (showBundleSizeSettings) {
        const isApple = appPlatform === undefined || getIsApplePlatform(appPlatform);
        const initialConditions: BundleSizeIncreaseCondition[] =
            notification.bundleSizeIncreaseConditions?.length ? notification.bundleSizeIncreaseConditions : [];

        const bundleSizeTypeOptions = [
            { value: BundleSizeConditionType.Download, label: 'Download size' },
            {
                value: BundleSizeConditionType.Install,
                label: isApple ? 'Install size' : 'Install size - not available for Android',
                disabled: !isApple,
            },
        ];
        const bundleSizeConditionsField = {
            label: 'Notify when bundle size increases (compared to live release) by more than:',
            name: 'bundleSizeIncreaseConditions',
            fieldType: FieldType.Custom,
            initialValue: initialConditions,
            style: { paddingBottom: 10 },
            rules: [
                () => ({
                    validator: (_, value: BundleSizeIncreaseCondition[] | undefined) => {
                        const conditions = value || [];
                        const types = conditions.map((c) => c?.type).filter(Boolean);
                        const seen = new Set<string>();
                        for (const t of types) {
                            if (seen.has(t)) {
                                return Promise.reject(new Error('You may only have one condition per type'));
                            }
                            seen.add(t);
                        }
                        return Promise.resolve();
                    },
                }),
            ],
            renderField: () => {
                const BundleSizeConditionsList = () => {
                    const form = Form.useFormInstance();
                    return (
                        <Form.List name="bundleSizeIncreaseConditions">
                            {(listFields, { add, remove }) => (
                                <Space direction="vertical" style={{ width: '100%' }} size={16}>
                                    {listFields.map(({ key, name, ...rest }) => (
                                        <Flex
                                            key={key}
                                            align="flex-start"
                                            gap={8}
                                            wrap="wrap"
                                            style={{
                                                width: '100%',
                                                backgroundColor: antGrey.grey2,
                                                borderRadius: 4,
                                                padding: '20px 30px',
                                            }}
                                        >
                                            <Form.Item
                                                {...rest}
                                                name={[name, 'type']}
                                                rules={[{ required: true }]}
                                                style={{ marginBottom: 0, minWidth: 140 }}
                                            >
                                                <Select placeholder="Type" options={bundleSizeTypeOptions} />
                                            </Form.Item>
                                            <Form.Item
                                                name={[name, 'value']}
                                                rules={[
                                                    { required: true, message: 'Value is required' },
                                                    {
                                                        validator: (_, val) => {
                                                            if (form?.getFieldValue('enabled') === false)
                                                                return Promise.resolve();
                                                            if (val == null || val === '') return Promise.resolve();
                                                            if (Number(val) <= 0) {
                                                                return Promise.reject(
                                                                    new Error('Value must be greater than 0'),
                                                                );
                                                            }
                                                            return Promise.resolve();
                                                        },
                                                    },
                                                ]}
                                                style={{ marginBottom: 0, width: 100 }}
                                            >
                                                <InputNumber min={1} max={10000} precision={0} />
                                            </Form.Item>
                                            <Form.Item
                                                name={[name, 'unit']}
                                                rules={[{ required: true }]}
                                                style={{ marginBottom: 0, minWidth: 100 }}
                                            >
                                                <Select
                                                    placeholder="Unit"
                                                    options={[
                                                        { value: BundleSizeConditionUnit.MB, label: 'MB' },
                                                        { value: BundleSizeConditionUnit.Percent, label: '% change' },
                                                    ]}
                                                />
                                            </Form.Item>
                                            <Button
                                                icon={<DeleteOutlined style={{ color: runwayColors.statusRed }} />}
                                                danger
                                                type="link"
                                                onClick={() => remove(name)}
                                            />
                                        </Flex>
                                    ))}
                                    <Form.Item noStyle shouldUpdate>
                                        {() => (
                                            <Flex
                                                justify="flex-start"
                                                align="center"
                                                style={{
                                                    width: '100%',
                                                    minHeight: 22,
                                                    paddingLeft: 30,
                                                    ...(listFields.length === 0 ? { marginTop: 12 } : {}),
                                                }}
                                                gap={8}
                                            >
                                                <Button
                                                    icon={<PlusOutlined style={{ color: runwayColors.primary }} />}
                                                    disabled={isApple ? listFields.length >= 2 : listFields.length >= 1}
                                                    onClick={() => {
                                                        const current =
                                                            form?.getFieldValue('bundleSizeIncreaseConditions') ?? [];
                                                        const usedTypes = new Set(
                                                            (current as BundleSizeIncreaseCondition[])
                                                                .map((c) => c?.type)
                                                                .filter(Boolean),
                                                        );
                                                        const enabledOptions = bundleSizeTypeOptions.filter(
                                                            (opt) => !opt.disabled,
                                                        );
                                                        const nextType =
                                                            enabledOptions.find((opt) => !usedTypes.has(opt.value))
                                                                ?.value ?? BundleSizeConditionType.Download;
                                                        add({
                                                            type: nextType,
                                                            unit: BundleSizeConditionUnit.MB,
                                                            value: 10,
                                                        });
                                                    }}
                                                >
                                                    {listFields.length === 0 ?
                                                        'Add condition'
                                                    :   'Add another condition'}
                                                </Button>
                                            </Flex>
                                        )}
                                    </Form.Item>
                                </Space>
                            )}
                        </Form.List>
                    );
                };
                return <BundleSizeConditionsList />;
            },
        };
        triggerFields.push(bundleSizeConditionsField);

        if (isApple) {
            const hasInitialCellular =
                notification.bundleSizeCellularDownloadLimitThresholdMB != null &&
                Number(notification.bundleSizeCellularDownloadLimitThresholdMB) >= 1;
            const bundleSizeCellularLimitField = {
                label: "Notify when bundle download size approaches within threshold of Apple's\u00A0200\u00A0MB cellular limit:",
                name: 'bundleSizeCellularDownloadLimitThresholdMB',
                fieldType: FieldType.Custom,
                initialValue: notification.bundleSizeCellularDownloadLimitThresholdMB,
                style: { paddingBottom: 10 },
                renderField: () => {
                    const CellularLimitField = () => {
                        const form = Form.useFormInstance();
                        const [showCellularInput, setShowCellularInput] = React.useState(hasInitialCellular);
                        return (
                            <Space direction="vertical" style={{ width: '100%' }} size={16}>
                                {showCellularInput ?
                                    <Flex
                                        align="center"
                                        gap={8}
                                        wrap="wrap"
                                        style={{
                                            width: '100%',
                                            backgroundColor: antGrey.grey2,
                                            borderRadius: 4,
                                            padding: '20px 30px',
                                        }}
                                    >
                                        <Form.Item
                                            name="bundleSizeCellularDownloadLimitThresholdMB"
                                            style={{ marginBottom: 0 }}
                                            rules={[{ required: true, message: 'Value is required' }]}
                                        >
                                            <InputNumber
                                                min={1}
                                                max={199}
                                                precision={0}
                                                style={{ minWidth: 120 }}
                                                addonAfter="MB"
                                            />
                                        </Form.Item>
                                        <Button
                                            icon={<DeleteOutlined style={{ color: runwayColors.statusRed }} />}
                                            danger
                                            type="link"
                                            onClick={() => {
                                                form?.setFieldValue(
                                                    'bundleSizeCellularDownloadLimitThresholdMB',
                                                    undefined,
                                                );
                                                setShowCellularInput(false);
                                            }}
                                        />
                                    </Flex>
                                :   <Flex
                                        justify="flex-start"
                                        align="center"
                                        style={{
                                            width: '100%',
                                            minHeight: 22,
                                            paddingLeft: 30,
                                            marginTop: 12,
                                        }}
                                        gap={8}
                                    >
                                        <Button
                                            icon={<PlusOutlined style={{ color: runwayColors.primary }} />}
                                            onClick={() => setShowCellularInput(true)}
                                        >
                                            Add condition
                                        </Button>
                                    </Flex>
                                }
                            </Space>
                        );
                    };
                    return <CellularLimitField />;
                },
            };
            triggerFields.push(bundleSizeCellularLimitField);
        }

        const bundleSizeAlertNotifyForOptions = [
            { value: BundleSizeAlertNotifyFor.FirstBuildOnly, label: 'First build that exceeds threshold only' },
            { value: BundleSizeAlertNotifyFor.AllBuilds, label: 'Every build that exceeds threshold' },
        ];
        const bundleSizeAlertNotifyForField = {
            label: 'For a given release, send notification for:',
            name: 'bundleSizeAlertNotifyFor',
            fieldType: FieldType.Custom,
            initialValue: notification.bundleSizeAlertNotifyFor ?? BundleSizeAlertNotifyFor.FirstBuildOnly,
            style: { paddingBottom: 18 },
            renderField: () => <Select options={bundleSizeAlertNotifyForOptions} style={{ minWidth: 280 }} />,
        };
        triggerFields.push(bundleSizeAlertNotifyForField);
    }

    if (notification.allowEmails) {
        channelFields.push(
            {
                name: 'notificationChannels',
                initialValue: notification.notificationChannels || [NotificationDestination.Slack],
                fieldType: FieldType.Custom,
                rules: [{ required: true }],
                style: { marginTop: 0, marginBottom: 0 },
                extraFormItemProps: { hidden: true },
                renderField: () => <span aria-hidden />,
            },
            ...(checkboxActions?.slackChecked === false && checkboxActions?.emailChecked === false ?
                [createErrorField('Please select at least one notification channel')]
            :   []),
        );
    } else {
        channelFields.push({
            name: 'notificationChannels',
            initialValue: [NotificationDestination.Slack],
            fieldType: FieldType.Custom,
            renderField: () => null,
            skipFormItemWrapper: true,
        });
    }

    if (showIncludeNewIssuesSetting) {
        const includeNewIssuesField = {
            label: '',
            name: 'includeNewIssuesIdentifiedByRunway',
            fieldType: FieldType.Custom,
            initialValue: notification.includeNewIssuesIdentifiedByRunway ?? false,
            extraFormItemProps: {
                valuePropName: 'checked',
                dependencies: ['notificationChannels'],
            },
            renderField: (_, __, ___, ____) => {
                return (
                    <Flex>
                        <Checkbox
                            defaultChecked={notification.includeNewIssuesIdentifiedByRunway ?? false}
                            disabled={isDisabled}
                        >
                            Include new stability issues
                        </Checkbox>
                        <TooltipInfoIcon tooltipContent="This will append information to this notification about any new stability issues identified by your stability monitoring integration (if connected)" />
                    </Flex>
                );
            },
        };
        fields.push(includeNewIssuesField);
    }

    if (showThreadWithRelatedNotifications) {
        const tooltipContent = threadWithRelatedNotificationsTooltip(notification.id as AppNotificationType);
        const threadCheckboxLabel =
            isPhasedRolloutNotification ?
                `Thread related ${rolloutTypeWord} notifications`
            :   'Thread related notifications on Slack';
        const threadWithRelatedNotificationsField: FormFieldData = {
            label: '',
            name: 'threadWithRelatedNotifications',
            fieldType: FieldType.Custom,
            initialValue: notification.threadWithRelatedNotifications ?? false,
            skipFormItemWrapper: true,
            renderField: (_, __, ___, form) => {
                const { slack: isSlackEnabled } = getNotificationDestinationsState(form);
                return (
                    <ThreadAndBroadcastCheckboxes
                        notification={notification}
                        isPhasedRolloutNotification={isPhasedRolloutNotification}
                        threadCheckboxLabel={threadCheckboxLabel}
                        tooltipContent={tooltipContent}
                        isDisabled={isDisabled}
                        isSlackEnabled={isSlackEnabled}
                    />
                );
            },
        };
        fields.push(threadWithRelatedNotificationsField);
    }

    if (showThreadHealthMetrics) {
        const threadHealthMetricsField = {
            label: '',
            name: 'threadHealthMetrics',
            fieldType: FieldType.Custom,
            skipFormItemWrapper: true,
            initialValue: notification.threadHealthMetrics ?? false,
            renderField: (_, __, ___, form) => {
                const { slack: isSlackEnabled } = getNotificationDestinationsState(form);

                return (
                    <Form.Item
                        name="threadHealthMetrics"
                        valuePropName="checked"
                        dependencies={['notificationChannels']}
                    >
                        <Checkbox disabled={isDisabled || !isSlackEnabled}>
                            Move health metrics into a Slack thread reply
                        </Checkbox>
                    </Form.Item>
                );
            },
        };
        fields.push(threadHealthMetricsField);
    }

    const isSubmitNotification = [
        AppNotificationType.ManualSubmitToAppStore,
        AppNotificationType.AutoSubmitToAppStore,
    ].includes(notification.id as AppNotificationType);
    const hasPMIntegration = connectedCapabilities.includes(IntegrationCapability.FeatureManagement);

    if (isSubmitNotification) {
        const includeTicketListField: FormFieldData = {
            label: '',
            name: 'includeTicketListInSubmitNotifications',
            fieldType: FieldType.Custom,
            initialValue: notification.includeTicketListInSubmitNotifications ?? false,
            extraFormItemProps: {
                valuePropName: 'checked',
            },
            renderField: () => {
                return (
                    <Flex>
                        <Checkbox
                            defaultChecked={notification.includeTicketListInSubmitNotifications ?? false}
                            disabled={isDisabled || !hasPMIntegration}
                        >
                            Include a list of all tickets in the submission within this notification
                        </Checkbox>
                        <TooltipInfoIcon tooltipContent="This setting requires that Runway is integrated with your Project Management tool in integration settings" />
                    </Flex>
                );
            },
        };
        fields.push(includeTicketListField);
    }

    const isCherryPickNotification = notification.id === AppNotificationType.CherryPickFixRequest;

    if (isCherryPickNotification) {
        const includePROwnerField: FormFieldData = {
            label: '',
            name: 'includePROwnerInCherryPickNotifications',
            fieldType: FieldType.Custom,
            initialValue: notification.includePROwnerInCherryPickNotifications ?? false,
            extraFormItemProps: {
                valuePropName: 'checked',
            },
            renderField: () => {
                return (
                    <Checkbox
                        defaultChecked={notification.includePROwnerInCherryPickNotifications ?? false}
                        disabled={isDisabled}
                    >
                        Include PR owner in Slack notifications
                    </Checkbox>
                );
            },
        };
        fields.push(includePROwnerField);
    }

    const isFixRequestUpdatedNotification = notification.id === AppNotificationType.FixRequestUpdated;

    if (isFixRequestUpdatedNotification) {
        const fixRequestReviewNotifyForField: FormFieldData = {
            label: 'Send a notification when a fix request...',
            name: 'fixRequestReviewNotifyFor',
            fieldType: FieldType.Custom,
            initialValue: notification.fixRequestReviewNotifyFor || FixRequestReviewNotifyFor.ApprovalOrRejectionOnly,
            renderField: (data, value, onChange) => {
                return (
                    <Radio.Group value={value} onChange={onChange} disabled={isDisabled}>
                        <Radio value={FixRequestReviewNotifyFor.AllReviews}>
                            ...is rejected or approved, even if more approvals are required
                        </Radio>
                        <Radio value={FixRequestReviewNotifyFor.ApprovalOrRejectionOnly}>
                            ...is rejected or has all required approvals
                        </Radio>
                    </Radio.Group>
                );
            },
        };
        triggerFields.push(fixRequestReviewNotifyForField);
    }

    const showPRCommitInfoField = [
        AppNotificationType.BuildFailed,
        AppNotificationType.BuildStarted,
        AppNotificationType.BuildAvail,
        AppNotificationType.BuildAvailArtifacts,
    ].includes(notification.id as AppNotificationType);

    if (showPRCommitInfoField) {
        const includePRCommitInfoField: FormFieldData = {
            label: '',
            name: 'includePRCommitInfo',
            fieldType: FieldType.Custom,
            initialValue: notification?.includePRCommitInfo ?? true,
            extraFormItemProps: {
                valuePropName: 'checked',
            },
            renderField: () => {
                return (
                    <Checkbox defaultChecked={notification?.includePRCommitInfo ?? true} disabled={isDisabled}>
                        Include PR/commit info in notification
                    </Checkbox>
                );
            },
        };
        fields.push(includePRCommitInfoField);
    }

    const showIncludeFixDetailsField = notification.id === AppNotificationType.FixRequestCreated;

    if (showIncludeFixDetailsField) {
        const includeFixDetailsField: FormFieldData = {
            label: '',
            name: 'includeFixRequestDetails',
            fieldType: FieldType.Custom,
            initialValue: notification?.includeFixRequestDetails ?? true,
            extraFormItemProps: {
                valuePropName: 'checked',
            },
            renderField: () => {
                return (
                    <Checkbox defaultChecked={notification?.includeFixRequestDetails ?? true} disabled={isDisabled}>
                        Include fix details in notification
                    </Checkbox>
                );
            },
        };
        fields.push(includeFixDetailsField);
    }

    const showIncludeDraftPRsField =
        notification.id === AppNotificationType.FixRequestCreated || notification.id === AppNotificationType.FixCreated;

    if (showIncludeDraftPRsField) {
        const includeDraftPRsField: FormFieldData = {
            label: '',
            name: 'includeDraftPRs',
            fieldType: FieldType.Custom,
            initialValue: notification?.includeDraftPRs ?? false,
            extraFormItemProps: {
                valuePropName: 'checked',
            },
            renderField: () => {
                return (
                    <Flex>
                        <Checkbox defaultChecked={notification?.includeDraftPRs ?? false} disabled={isDisabled}>
                            Include fix requests on draft PRs
                        </Checkbox>
                        <TooltipInfoIcon tooltipContent="When this option is disabled, the notification is sent once the pull request is ready for review." />
                    </Flex>
                );
            },
        };
        fields.push(includeDraftPRsField);
    }

    const isRegressionStatusNotification = notification.id === AppNotificationType.RegressionStatusUpdated;

    if (isRegressionStatusNotification) {
        const includeCommentsField: FormFieldData = {
            label: '',
            name: 'includeCommentsInRegressionItemNotification',
            fieldType: FieldType.Custom,
            initialValue: notification.includeCommentsInRegressionItemNotification ?? false,
            extraFormItemProps: {
                valuePropName: 'checked',
            },
            renderField: () => {
                return (
                    <Checkbox
                        defaultChecked={notification.includeCommentsInRegressionItemNotification ?? false}
                        disabled={isDisabled}
                    >
                        Include comments in notifications
                    </Checkbox>
                );
            },
        };
        fields.push(includeCommentsField);
    }

    if (showMonitoringConditionsSetting) {
        const gateConditionTypes = automationConditionsForAutomationType(
            AutomationType.AutoHaltUnstablePhasedReleases,
            appStoreType,
        );
        const monitoringConditionOptions: MonitoringConditionOption[] = gateConditionTypes.map((type) => ({
            id: type,
            title: displayTextForAutomationConditionType(type),
        }));

        const rolloutNoun = rolloutNounForAppStoreType(appStoreType);
        const rolloutDayTriggerOption: NotificationTriggerOption = {
            id: NotificationTriggerConditionType.RolloutDay,
            title: displayTextForNotificationTriggerConditionType(
                NotificationTriggerConditionType.RolloutDay,
                appStoreType,
            ),
            input: { min: 1, max: maxRolloutDay, precision: 0, descriptionText: `${rolloutNoun} day` },
        };
        const rolloutPercentageTriggerOption: NotificationTriggerOption = {
            id: NotificationTriggerConditionType.RolloutPercentage,
            title: displayTextForNotificationTriggerConditionType(
                NotificationTriggerConditionType.RolloutPercentage,
                appStoreType,
            ),
            input: { min: 1, max: 100, precision: 0, addonAfter: '%', descriptionText: `${rolloutNoun} percentage` },
        };

        const triggerOptions: NotificationTriggerOption[] = [
            ...(gateConditionTypes.includes(MonitoringAutomationConditionType.PhasedReleaseDay) ?
                [rolloutPercentageTriggerOption]
            : gateConditionTypes.includes(MonitoringAutomationConditionType.StagedRolloutPercentage) ?
                [rolloutDayTriggerOption]
            :   []),
            {
                id: NotificationTriggerConditionType.PreviousReleaseFullyRolledOut,
                title: displayTextForNotificationTriggerConditionType(
                    NotificationTriggerConditionType.PreviousReleaseFullyRolledOut,
                ),
            },
        ];

        triggerFields.push(
            generateHaltPhasedRolloutConditionGroupsField(
                notification.conditionGroups?.length ?
                    notification.conditionGroups
                :   legacyThresholdsAsConditionGroups(notification, stabilityIntegrations),
                connectedCapabilities,
                monitoringConditionOptions,
                monitoringMetrics,
                healthMetricsLink,
                stabilityIntegrations,
                'only under these conditions:',
                triggerOptions,
                'notification',
            ),
        );
    }

    const showDirectDownloadLinkSettings = notification.id === AppNotificationType.BuildAvailArtifacts;

    if (showDirectDownloadLinkSettings) {
        const directDownloadLinkField: FormFieldData = {
            label: '',
            name: 'includeDirectDownloadLink',
            fieldType: FieldType.Custom,
            initialValue: notification.includeDirectDownloadLink ?? false,
            // Outer Form.Item must not wrap the limit fields: nested names merge into includeDirectDownloadLink and
            // break the boolean when InputNumber updates (see DirectDownloadLinkLimitFields).
            skipFormItemWrapper: true,
            renderField: () => (
                <Space direction="vertical" style={{ width: '100%', marginTop: 4, marginBottom: 22 }} size={8}>
                    <Flex align="center" gap={8} wrap="nowrap">
                        <Form.Item name="includeDirectDownloadLink" valuePropName="checked" noStyle>
                            <Checkbox disabled={isDisabled}>Include direct download link(s) in notification</Checkbox>
                        </Form.Item>
                        <TooltipInfoIcon tooltipContent="When enabled, a direct download link for each available artifact will be included in the notification and recipients can use those links to download artifacts without first authenticating in Runway." />
                    </Flex>
                    <DirectDownloadLinkLimitFields notification={notification} isDisabled={isDisabled} />
                </Space>
            ),
        };
        fields.push(directDownloadLinkField);
    }

    if (notification.id === BuildDistroNotificationType.NewBuildsAvailable) {
        fields.push({
            label: '',
            name: 'includeQRCode',
            data: 'Include install QR code in notification',
            fieldType: FieldType.Checkbox,
            initialValue: notification.includeQRCode ?? true,
            disabled: isDisabled,
            rules: [],
        });
    }

    const showBrokenIntegrationSettings = notification.id === AppNotificationType.IntegrationBroken;

    if (showBrokenIntegrationSettings) {
        const integrationOptions = appIntegrations.map((integration) => ({
            value: integration.installationId,
            label: integration.alias || integration.name,
        }));

        fields.push({
            name: 'brokenIntegrationNotifyMode',
            fieldType: FieldType.Custom,
            initialValue: notification.brokenIntegrationNotifyMode ?? BrokenIntegrationNotifyMode.All,
            skipFormItemWrapper: true,
            renderField: () => (
                <div style={{ marginTop: 12, marginBottom: 16 }}>
                    <Form.Item
                        name="brokenIntegrationNotifyMode"
                        initialValue={notification.brokenIntegrationNotifyMode ?? BrokenIntegrationNotifyMode.All}
                        style={{ marginBottom: 0 }}
                    >
                        <Radio.Group disabled={isDisabled}>
                            <Space direction="vertical" size={4} style={{ paddingBottom: 4 }}>
                                <Text type="secondary">Applies to...</Text>
                                <Radio value={BrokenIntegrationNotifyMode.All}>Any integration</Radio>
                                <Radio value={BrokenIntegrationNotifyMode.Specified}>Specified integrations only</Radio>
                            </Space>
                        </Radio.Group>
                    </Form.Item>
                    <BrokenIntegrationScopeFields
                        notification={notification}
                        isDisabled={isDisabled}
                        integrationOptions={integrationOptions}
                    />
                </div>
            ),
        });

        triggerFields.push({
            name: 'brokenIntegrationDurationValue',
            fieldType: FieldType.Custom,
            initialValue: notification.brokenIntegrationDurationValue ?? DEFAULT_BROKEN_INTEGRATION_DURATION_VALUE,
            skipFormItemWrapper: true,
            renderField: () => (
                <Form.Item
                    label="Send a notification if the issue has persisted for at least..."
                    style={{ marginTop: 8, marginBottom: 24 }}
                >
                    <Flex gap={8} wrap="nowrap">
                        <Form.Item
                            name="brokenIntegrationDurationValue"
                            initialValue={
                                notification.brokenIntegrationDurationValue ?? DEFAULT_BROKEN_INTEGRATION_DURATION_VALUE
                            }
                            noStyle
                        >
                            <InputNumber min={1} precision={0} style={{ width: 100 }} disabled={isDisabled} />
                        </Form.Item>
                        <Form.Item
                            name="brokenIntegrationDurationUnit"
                            initialValue={
                                notification.brokenIntegrationDurationUnit ?? DEFAULT_BROKEN_INTEGRATION_DURATION_UNIT
                            }
                            noStyle
                        >
                            <Select
                                disabled={isDisabled}
                                style={{ width: 110 }}
                                options={[
                                    { value: BrokenIntegrationDurationUnit.Minutes, label: 'minutes' },
                                    { value: BrokenIntegrationDurationUnit.Hours, label: 'hours' },
                                    { value: BrokenIntegrationDurationUnit.Days, label: 'days' },
                                ]}
                            />
                        </Form.Item>
                    </Flex>
                </Form.Item>
            ),
        });
    }

    const mentionTypeField: FormFieldData = {
        name: 'mentionType',
        fieldType: FieldType.Custom,
        initialValue: selectedMentionType,
        skipFormItemWrapper: true,
        renderField: () => (
            <MentionTypeSelector
                isDisabled={isDisabled}
                isSelectionRequired={isSlackOptionRequired(SlackOption.Mentions)}
                getNotificationDestinationsState={getNotificationDestinationsState}
            />
        ),
    };

    const mentionReleasePilotField: FormFieldData = {
        label: '',
        name: 'mentionReleasePilot',
        fieldType: FieldType.Custom,
        initialValue: selectedMentionType === MentionType.ReleasePilot,
        extraFormItemProps: { hidden: true },
        renderField: () => null,
    };

    const channelsHelpMessage =
        hasProviderAndNotificationIntegration ?
            <>
                <Text type="secondary">
                    Pattern token strings are supported{' '}
                    <Popover
                        content={<PatternTokenHelperTextComponent availableTokens={CommsChannelAvailableTokens} />}
                    >
                        <InfoCircleOutlined style={{ color: antGrey.grey7 }} />
                    </Popover>{' '}
                    <Tooltip title="If Runway cannot resolve selected tokens (e.g., no release name is set), the channel will not be created. Changing the release name or version during a release may disrupt notification delivery.">
                        <WarningFilled style={{ color: runwayColors.statusYellow, paddingLeft: 6 }} />
                    </Tooltip>
                </Text>
                {primaryChannels && (
                    <div style={{ paddingTop: 8 }}>
                        <Text type="secondary">Primary channel(s): {primaryChannels}</Text>
                    </div>
                )}
            </>
        :   <Text type="secondary">Notifications integration not installed.</Text>;

    const channelOptions = [
        ...availableChannels,
        ...notification.channels.filter(
            (selected) => !availableChannels.some((available) => available.id === selected.id),
        ),
    ];

    const isTeamsProvider = provider?.type === IntegrationProviderType.AzureActiveDirectory;
    const teamsProviderData = isTeamsProvider ? (provider?.data as AzureActiveDirectoryProviderData) : null;

    const channelsTooltipContent = (
        <div style={{ maxWidth: 400 }}>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
                <li>
                    {`If the 'Create release-specific ${commsProviders}${' '} channel(s)' automation is enabled and a
                    tokenized channel name is configured, Runway will automatically create a new ${commsProviders}${' '}
                    channel(s) for releases according to the entered pattern.`}
                </li>
                {isSlackProvider && (
                    <li>
                        For private channels, you must first invite the Runway bot for Slack to the channel with the
                        @Runway command, then enter the channel ID (not name) as free text here.
                    </li>
                )}
            </ul>
        </div>
    );

    const channelsField = {
        label: (
            <span>
                Channel(s) (overrides primary){' '}
                <Popover content={channelsTooltipContent} placement="top">
                    <InfoCircleOutlined style={{ color: antGrey.grey6 }} />
                </Popover>
            </span>
        ),
        name: 'channels',
        helpMessage: channelsHelpMessage,
        initialValue: notification.channels.map((chan) => chan.id),
        fieldType: FieldType.Custom,
        extraFormItemProps: {
            dependencies: ['notificationChannels'],
        },
        rules: [
            ({ getFieldValue }) => ({
                validator: (_, values) => {
                    const currentChannels = getFieldValue('notificationChannels') || [];
                    const isSlackEnabled = hasProviderAndNotificationIntegration && currentChannels.includes('SLACK');
                    return isSlackEnabled ? commsChannelsValidatorFunction(provider.type, values) : Promise.resolve();
                },
            }),
            {
                validator: (_, values) =>
                    isSlackOptionRequired(SlackOption.Channels) && !(values?.length > 0) ?
                        Promise.reject(new Error('Select or enter at least one channel'))
                    :   Promise.resolve(),
            },
        ],
        data: channelOptions,
        renderField: (data, _, __, form) => {
            const { slack: isSlackEnabled } = getNotificationDestinationsState(form);
            const fieldDisabled = isDisabled || !hasProviderAndNotificationIntegration || !isSlackEnabled;

            if (isTeamsProvider && teamsProviderData) {
                return (
                    <TeamsChannelOverrideSelect
                        allChannels={availableChannels as MicrosoftTeamsChannel[]}
                        selectedChannels={notification.channels}
                        teams={teamsProviderData.availableTeams ?? []}
                        disabled={fieldDisabled}
                    />
                );
            }

            return (
                <Select
                    placeholder={'Select or enter channel(s)'}
                    mode="tags"
                    notFoundContent={null}
                    showSearch
                    allowClear
                    filterOption={filterOptionLabel}
                    disabled={fieldDisabled}
                >
                    {data.map((channel, index) => {
                        return (
                            <Select.Option value={channel.id} key={index} label={channel.name}>
                                {channel.name}
                            </Select.Option>
                        );
                    })}
                </Select>
            );
        },
    };

    const customCopyField: FormFieldData = {
        name: 'customCopy',
        initialValue: notification.customCopy ?? '',
        fieldType: FieldType.Custom,
        helpMessage: (
            <Text type="secondary">
                Type @ to mention a user or group. Pattern token strings are also supported.{' '}
                <Popover
                    content={
                        <div style={{ overflow: 'scroll', maxWidth: '40vw', maxHeight: '40vh' }}>
                            <PatternTokenHelperTextComponent availableTokens={AllPatternTokens} />
                        </div>
                    }
                    placement="top"
                >
                    <InfoCircleOutlined style={{ color: antGrey.grey6 }} />
                </Popover>
            </Text>
        ),
        extraFormItemProps: {
            validateTrigger: ['onBlur', 'onChange'],
            dependencies: ['notificationChannels'],
        },
        rules: [
            ...patternTokenSyntaxValidation(),
            {
                validator: (_, value) =>
                    isSlackOptionRequired(SlackOption.CustomText) && !value?.trim() ?
                        Promise.reject(new Error('Please enter custom copy to append'))
                    :   Promise.resolve(),
            },
        ],
        renderField: (data, _, __, form) => {
            const { slack: isSlackEnabled } = getNotificationDestinationsState(form);
            return (
                <MarkdownEditor
                    autoFocus={false}
                    allowMentions
                    allowPatternedStrings
                    users={appUsers}
                    userGroups={userGroups}
                    disabled={isDisabled || !hasProviderAndNotificationIntegration || !isSlackEnabled}
                />
            );
        },
    };

    channelFields.push({
        fieldType: FieldType.WrappedGroup,
        groupedFields: [
            mentionTypeField,
            mentionedGroupsField,
            mentionedUsersField,
            mentionReleasePilotField,
            channelsField,
            customCopyField,
        ],
        groupChildrenWrapper: (children) => {
            return (
                <NotificationChannelSection
                    title={notificationsChannelTitle}
                    icon={
                        <IntegrationIcon
                            integrationId={isTeamsProvider ? IntegrationType.MicrosoftTeams : IntegrationType.Slack}
                        />
                    }
                    isChecked={notification.allowEmails ? (checkboxActions?.slackChecked ?? true) : undefined}
                    onToggle={
                        notification.allowEmails ?
                            (checked) =>
                                checkboxActions?.handleChannelCheckboxChange(NotificationDestination.Slack, checked)
                        :   undefined
                    }
                    disabled={isDisabled}
                    headerAction={checkboxActions?.slackHeaderAction}
                >
                    {slackOptions ?
                        <Flex vertical gap={12}>
                            <ChannelOptionToggle
                                label="Mention (@) individual users or user groups"
                                checked={slackOptions[SlackOption.Mentions].checked}
                                onChange={slackOptions[SlackOption.Mentions].onChange}
                                disabled={optionsDisabled}
                            >
                                {renderFormFields([
                                    mentionTypeField,
                                    mentionedGroupsField,
                                    mentionedUsersField,
                                    mentionReleasePilotField,
                                ])}
                            </ChannelOptionToggle>
                            <ChannelOptionToggle
                                label="Customize channel(s) to send to"
                                checked={slackOptions[SlackOption.Channels].checked}
                                onChange={slackOptions[SlackOption.Channels].onChange}
                                disabled={optionsDisabled}
                            >
                                {renderFormFields([channelsField])}
                            </ChannelOptionToggle>
                            <ChannelOptionToggle
                                label="Append custom text"
                                checked={slackOptions[SlackOption.CustomText].checked}
                                onChange={slackOptions[SlackOption.CustomText].onChange}
                                disabled={optionsDisabled}
                            >
                                {renderFormFields([customCopyField])}
                            </ChannelOptionToggle>
                        </Flex>
                    :   children}
                </NotificationChannelSection>
            );
        },
    });

    if (notification.allowEmails) {
        const emailField = {
            label: 'Recipients',
            name: 'emailsToInclude',
            helpMessage: 'Enter one or more email addresses to receive this type of notification via email.',
            initialValue: notification.emailsToInclude || [],
            fieldType: FieldType.Custom,
            extraFormItemProps: {
                dependencies: ['notificationChannels'],
            },
            rules: emailValidationRules([], !isDisabled && checkboxActions?.emailChecked === true),
            data: notification.emailsToInclude || [],
            renderField: (data, _, __, form) => {
                const { email: isEmailEnabled } = getNotificationDestinationsState(form);

                return (
                    <Select
                        placeholder="Enter email addresses"
                        mode="tags"
                        notFoundContent={null}
                        showSearch
                        allowClear
                        tokenSeparators={[',']}
                        disabled={isDisabled || !isEmailEnabled}
                    >
                        {data.map((email, index) => {
                            return (
                                <Select.Option value={email} key={index}>
                                    {email}
                                </Select.Option>
                            );
                        })}
                    </Select>
                );
            },
        };

        channelFields.push({
            fieldType: FieldType.WrappedGroup,
            groupedFields: [emailField],
            groupChildrenWrapper: (children) => (
                <NotificationChannelSection
                    title="Email notifications"
                    icon={<MailOutlined style={{ fontSize: 16, color: runwayColors.primary }} />}
                    isChecked={checkboxActions?.emailChecked ?? false}
                    onToggle={(checked) =>
                        checkboxActions?.handleChannelCheckboxChange(NotificationDestination.Email, checked)
                    }
                    disabled={isDisabled}
                >
                    {children}
                </NotificationChannelSection>
            ),
        });
    }

    return { enabled: enabledField, settings: fields, channels: channelFields, triggers: triggerFields };
};
